export default __webpack_public_path__ + "static/social-estados-535ef86e354a74d11df4f17b8ae22ea0.png";